import isNil from 'lodash/isNil';

import { messages } from '@qality/common-messages';
import {
  AdHocExecution,
  TestCycleForExecution,
  TestCycleForExecutionResponse,
  TestCycleOption,
} from '@qality/common-model/src/TestCycle';
import {
  StorageOfUniqueServices,
  TestCyclesService,
} from '@qality/common-service';

import UserImpl from '../../../select/UserTestImpl';
import { DEFAULT_SELECT_VALUE } from '../ExecutionDialog';

export const mapTestCycleForExecutionToOption = (
  item: TestCycleForExecution | AdHocExecution
): TestCycleOption => {
  const testCycleOptionData = {
    name: item.name,
    testCaseInCycleId:
      'testCaseInCycleId' in item ? item.testCaseInCycleId : null,
    testCycleId: 'testCycleId' in item ? item.testCycleId : null,
    testExecutionId: 'testExecutionId' in item ? item.testExecutionId : null,
    createdDate: 'createdDate' in item ? item.createdDate : null,
    executionAssignee:
      'executionAssignee' in item ? item.executionAssignee : null,
    statusObject: 'statusObject' in item ? item.statusObject : null,
    projectId: 'projectId' in item ? item.projectId : null,
    projectKey: 'projectKey' in item ? item.projectKey : null,
    projectAvatarUrl: 'projectAvatarUrl' in item ? item.projectAvatarUrl : '',
  };

  return {
    value: testCycleOptionData,
    label:
      'projectKey' in item ? `(${item.projectKey}) ${item.name}` : item.name,
  };
};

export const getUserAccountIdsFromOptions = (
  optionsArg: Array<TestCycleOption>
): Array<string> => {
  const userIds = [
    ...new Set(
      optionsArg
        .map((option) => option.value.executionAssignee)
        .filter((id): id is string => id !== null && id !== undefined)
    ),
  ];
  return userIds;
};

export const initializeAvatarUrlsForUsers = (
  optionsArg: Array<TestCycleOption>,
  usersMap: Record<string, UserImpl>
): Array<TestCycleOption> => {
  const updatedOptions: TestCycleOption[] = optionsArg.map((option) => {
    const matchingUser = usersMap[option.value.executionAssignee];

    return {
      value: {
        ...option.value,
        executionAssigneeAvatarUrl: matchingUser
          ? matchingUser.avatarUrls['24x24']
          : undefined,
        executionAssigneeName: matchingUser
          ? matchingUser.displayName
          : 'Unassigned',
      },
      label: option.label,
    };
  });

  return updatedOptions;
};

export const fetchTestCaseInCycleForExecutions = async (
  PAGE_NUMBER: number,
  testCaseId: string,
  text?: string
): Promise<Array<TestCycleOption>> => {
  try {
    const response: TestCycleForExecutionResponse =
      await TestCyclesService.fetchTestCyclesForExecution(
        PAGE_NUMBER,
        testCaseId
      );

    const testCycles: Array<TestCycleForExecution | AdHocExecution> =
      response.content;

    if (isNil(text) || DEFAULT_SELECT_VALUE.name.toLowerCase().includes(text)) {
      testCycles.unshift(DEFAULT_SELECT_VALUE);
    }

    const options: Array<TestCycleOption> = testCycles.map(
      mapTestCycleForExecutionToOption
    );
    return options;
  } catch (e) {
    StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
      e,
      messages['error.testCases.fetchingTestCycles.message']
    );
  }
};
